export class User {
  // Unique identifier from MongoDB
  id?: string;

  // Full name of the user
  name!: string;

  // Login ID (email or username)
  loginId!: string;

  // User's password (NOTE: Store hashed on server side only)
  password!: string;

  // Roles like "admin", "customer", etc.
  roles: string[] = [];

  // Dynamic details (can hold profile, preferences, etc.)
  details: { [key: string]: any } = {};

//   constructor(init?: Partial<User>) {
//     Object.assign(this, init);
//   }
}
